import { Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SettingsWorkspace from 'components/layouts/settings-workspace/settings-workspace';
import { useDialog } from 'components/layouts/page-with-dialog/dialog-context';
import { SettingsTab } from 'components/layouts/settings-workspace/props';
import { useUserProfileQuery } from 'app/store';
import ProfileFormTab from './profile-form.tab';
import SecurityTab from './security.tab';
import ActiveSessionsTab from './active-sessions.tab';
import ApiTokenTab from './api-token.tab';
import WalletsTab from './wallets.tab';
import NotificationsTab from './notifications.tab';
import AdressesTab from './addresses.tab';

const Tabs = () => {
    const { openDialog } = useDialog();
    const { data: profile } = useUserProfileQuery();
    const telegramId = profile?.telegram_id;

    const profileSettingTabs: SettingsTab[] = [
        {
            label: 'پروفایل',
            url: 'account',
            icon: (
                <i
                    className="fa-light fa-user-circle"
                    style={{ fontSize: '16px' }}
                />
            ),
            component: <ProfileFormTab />,
        },
        {
            label: 'تایید دومرحله ای',
            url: 'security',
            icon: <i className="fa-light fa-shield-halved"></i>,
            component: <SecurityTab />,
        },
        {
            label: 'نشست‌های فعال',
            url: 'active-sessions',
            icon: <i className="fa-light fa-desktop"></i>,
            component: <ActiveSessionsTab />,
        },
        {
            label: 'توکن وب سرویس',
            url: 'api-token',
            icon: <i className="fa-light fa-key"></i>,
            component: <ApiTokenTab />,
        },
        {
            label: 'کیف پول',
            url: 'wallets',
            icon: <i className="fa-light fa-wallet"></i>,
            component: <WalletsTab />,
        },
        {
            label: 'تنظیمات اطلاع‌رسانی',
            url: 'notifications',
            icon: <i className="fa-light fa-bell"></i>,
            component: <NotificationsTab />,
            action: (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flexWrap: 'wrap',
                    }}
                >
                    {Boolean(String(telegramId ?? '').trim()) && (
                        <Button
                            variant="outlined"
                            onClick={() => openDialog('disable-telegram-bot')}
                            sx={(theme) => {
                                const isDark = theme.palette.mode === 'dark';
                                const tone = isDark
                                    ? theme.palette.error.light
                                    : theme.palette.error.dark;

                                return {
                                    fontSize: { xs: '12px', md: '14px' },
                                    color: tone,
                                    borderColor: alpha(tone, isDark ? 0.42 : 0.3),
                                    bgcolor: alpha(tone, isDark ? 0.08 : 0.035),
                                    '&:hover': {
                                        color: tone,
                                        borderColor: alpha(
                                            tone,
                                            isDark ? 0.62 : 0.5,
                                        ),
                                        bgcolor: alpha(
                                            tone,
                                            isDark ? 0.14 : 0.07,
                                        ),
                                    },
                                };
                            }}
                        >
                            غیرفعالسازی ربات
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={() => openDialog('set-telegram-id')}
                        sx={{ fontSize: { xs: '12px', md: '14px' } }}
                    >
                        تنظیم شناسه تلگرام
                    </Button>
                </Box>
            ),
        },
        {
            label: 'آدرس ها',
            url: 'addresses',
            icon: <i className="fa-light fa-location-dot"></i>,
            component: <AdressesTab />,
            action: (
                <Button
                    variant="contained"
                    onClick={() => openDialog('new-address')}
                    sx={{ fontSize: { xs: '12px', md: '14px' } }}
                >
                    افزودن آدرس
                </Button>
            ),
        },
    ];

    return (
        <SettingsWorkspace
            title="پروفایل"
            tabs={profileSettingTabs}
            dynamicTitle
        />
    );
};

export default Tabs;
